module.exports = function() {
  return new Worker(__webpack_public_path__ + "4bde0dba9c85a1a076ae.worker.js");
};